export enum SquashGameType {
    RALLY = "RALLY",
    ENGLISH_HIHO = "ENGLISH_HIHO"
}
export enum SquashGameFormat {
    WIN_BY_2 = "WIN_BY_2"
}

